import React from 'react';
import { Link } from 'react-router-dom';
import { useAuthDataContext } from './../__providers/AuthProvider'

//style
import '../assets/css/footer.css';

//images
import fb from '../assets/images/footer/fb.png';
import brand from '../assets/images/header/brand-white.png';
import ds from '../assets/images/footer/ds-logo.png';

//actions
import { handleOnlineStores } from '../__actions/tradeObjects'

//dispatcher
import { useDispatch } from 'react-redux'

function Footer() {
    const auth = useAuthDataContext()
    const dispatch = useDispatch()

    return (
        <footer>
            <div className="wrapper">
                <div className="top">
                    <div className="col">
                        <p>
                            Авто Обучение е интерактивно учебно помагало за кандидат-шофьори, което включва видео обучение и изпитни въпроси за всяка тема.
                        </p>
                        <a target="_blank" href="https://avtoobuchenie.bg/register" className="start-now">
                            Започни сега
                        </a>
                    </div>
                    {auth.isLogged ? <ul className="col">
                        <li>
                            <Link to="/">
                                Табла
                            </Link>
                        </li>
                        <li>
                            <a target="_blank" href="https://avtoobuchenie.bg/about-schools">
                                За автошколи
                            </a>
                        </li>
                        <li>
                            <a target="_blank" href="https://avtoobuchenie.bg/about-students">
                                За курсисти
                            </a>
                        </li>
                        <li>
                            <a target="_blank" href="https://avtoobuchenie.bg/driving-schools">
                                Автошколи
                            </a>
                        </li>
                        {auth.isLogged ? <li>
                            <a target="_blank"
                                href="https://avtoobuchenie.bg/trade-objects"
                                onClick={() => dispatch(handleOnlineStores())}
                            >
                                Търговски обекти
                            </a>
                        </li> : ''}
                    </ul> : ''}
                    <ul className="col">
                        <li>
                            <a target="_blank" href="https://avtoobuchenie.bg/terms">
                                Общи условия
                            </a>
                        </li>
                        <li>
                            <a target="_blank" href="https://avtoobuchenie.bg/cookies">
                                Бисквитки
                            </a>
                        </li>
                        <li>
                            <a target="_blank" href="https://avtoobuchenie.bg/privacy">
                                Лични данни
                            </a>
                        </li>
                    </ul>
                    <ul className="col">
                        <li>
                            <h3>
                                Контакти
                            </h3>
                        </li>
                        <li>
                            <span>
                                тел.:
                           </span>
                            <a href="tel:+359 886 666 258">+359 886 666 258</a>
                        </li>
                        <li>
                            <span>
                                Е-поща:
                            </span>
                            <a href="mailto:team@avtoobuchenie.bg">team@avtoobuchenie.bg</a>
                        </li>
                        <li>
                            <a className="fb" href="https://www.facebook.com/avtoobuchenie" target="_blank"><img src={fb} at="facebook" /> / AvtoObuchenie</a>
                        </li>
                    </ul>
                </div>
                <div className="bottom">
                    <div className="left">
                        <a target="_blank" href="/" className="brand">
                            <img src={brand} alt="brand" />
                        </a>
                        <p>
                            © <span>{new Date().getFullYear()}</span>
                            Авто Обучение. Всички права запазени.
                        </p>
                    </div>
                    <div className="right">
                        <div className="ds">
                            <span>
                                Продукт на
                                </span>
                            <a href="https://danielstandard.com/" target="_blank">
                                <img src={ds} alt="Daniel Standard" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer;